import { useState } from 'react';

export const useVideoPreview = () => {
  const [openVideoPreview, setOpenVideoPreview] = useState<{ show: boolean; source: string | null }>({
    show: false,
    source: null
  });

  const handleCloseVideoPreview = () => {
    setOpenVideoPreview({ show: false, source: null });
  };

  const handleOpenVideoPreview = (source: string | null) => {
    if (!source) return;
    setOpenVideoPreview({ show: true, source });
  };

  return { openVideoPreview, handleOpenVideoPreview, handleCloseVideoPreview };
};
